<span class="badge" 
    [class.badge-status-draft]="status === 0"
    [class.badge-status-pending]="status === 1"
    [class.badge-status-signed]="status === 4"
    [class.badge-status-rejected]="status === 3"
    [class.badge-status-removed]="status === 5"
    [class.badge-status-canceled]="status === 6"> 
    {{ statusText }}
</span>